import React, { useEffect, useState } from 'react';
import Layout from '../Components/Layout';
import blog from '../Assets/images/blog-1.png'
import avt from '../Assets/images/avt-1.png'

import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { PostApiWithoutLogin } from '../apiService';
import { API_PATH, FRONTEND_URL } from '../const';
import { toast } from 'react-toastify';
import { useLocation } from "react-router-dom";
import Loader from '../Components/Layout/Loader';

function AllAdvs(props) {
    const location = useLocation();
    
    const categories = [
        {
            name: 'View all',
            posts: [
                {
                    id: 1,
                    img: blog,
                    avt: avt,
                    avtname: 'John',
                    tag: 'Design',
                    title: 'UX Review Presentations',
                    desc: 'How do you create compelling presentations that wow your collogues and impress your managers? ',
                    date: '5h ago',
                    commentCount: 5,
                    shareCount: 2,
                },
                {
                    id: 2,
                    img: blog,
                    avt: avt,
                    avtname: 'John',
                    tag: 'Design',
                    title: 'UX Review Presentations',
                    desc: 'How do you create compelling presentations that wow your collogues and impress your managers? ',
                    date: '5h ago',
                    commentCount: 5,
                    shareCount: 2,
                },
            ],
        },
        {
            name: 'Design',
            posts: [
                {
                    id: 1,
                    img: blog,
                    avt: avt,
                    avtname: 'John',
                    tag: 'Design',
                    title: 'UX Review Presentations',
                    desc: 'How do you create compelling presentations that wow your collogues and impress your managers? ',
                    date: '5h ago',
                    commentCount: 5,
                    shareCount: 2,
                },
                {
                    id: 2,
                    img: blog,
                    avt: avt,
                    avtname: 'John',
                    tag: 'Design',
                    title: 'UX Review Presentations',
                    desc: 'How do you create compelling presentations that wow your collogues and impress your managers? ',
                    date: '5h ago',
                    commentCount: 5,
                    shareCount: 2,
                },
            ],
        },
        {
            name: 'Product',
            posts: [
                {
                    id: 1,
                    img: blog,
                    avt: avt,
                    avtname: 'John',
                    tag: 'Design',
                    title: 'UX Review Presentations',
                    desc: 'How do you create compelling presentations that wow your collogues and impress your managers? ',
                    date: '5h ago',
                    commentCount: 5,
                    shareCount: 2,
                    
                },
                {
                    id: 2,
                    img: blog,
                    avt: avt,
                    avtname: 'John',
                    tag: 'Design',
                    title: 'UX Review Presentations',
                    desc: 'How do you create compelling presentations that wow your collogues and impress your managers? ',
                    date: '5h ago',
                    commentCount: 5,
                    shareCount: 2,
                },
            ],
        },
    ]

    const [adv_list, set_adv_list] = useState([]);
    const [search_text, set_search_text] = useState(location.state?.search_text ?? "");
    const [loader, set_loader] = useState(true);
    
    useEffect(() => {
        const delayDebounceFn = setTimeout(() =>  ExecuteSearch(search_text), 800)
        return () => clearTimeout(delayDebounceFn)
    }, [search_text])

    const ExecuteSearch = (searchparams) => {
        set_loader(true);
        const SumbitInquiryForm = Promise.resolve(PostApiWithoutLogin(API_PATH.SearchAdv, {searchparams}));
        SumbitInquiryForm.then(response => {
            if(response.status === 200){
                set_adv_list(response?.data?.data?.advs ?? []);
            } else toast.error("Could not find advs. Try again later!");
            set_loader(false);
        })
    }

    const formatDate = (date) => {
        const utcdate = new Date(date);
        return (utcdate.getDate() + "/" + (utcdate.getMonth()+1) + "/" + utcdate.getFullYear())
    }

    const formatDetails = (details) => {
        let formatedDetails = details.substring(0, 40) + " ...";
        return <p data-toggle="tooltip" title={details}>
            {formatedDetails};
        </p>
    }

    return (
        <Layout>
            {loader === true ? <Loader text={"Fetching your advertisements"}></Loader> : <></>}
            <section className='common-space-both container'>
                <div className='common-title text-center'>
                    <label className='font-semibold text-[#F0643B] py-4 inline-block text-lg'>All Advertisements</label>
                    <h1 className='text-black'><span>Discover the Best Deals & Services </span> Near you</h1>
                </div>
                <TabGroup className='mt-10'>
                    <div className='flex items-center mobilexl:flex-col'>
                        {/* <TabList className="flex gap-4 bg-[#F4F4F4] p-1 border border-[#57575733] rounded-xl">
                            {categories.map(({ name }) => (
                                <Tab
                                    key={name}
                                    className="rounded-xl py-2 px-3  font-semibold  focus:outline-none 
                          data-[selected]:bg-white data-[selected]:text-black 
                          data-[hover]:bg-gray-200/20"
                                >
                                    {name}
                                </Tab>
                            ))}
                        </TabList> */}
                        <div className='ml-auto relative mobilexl:w-full mobilexl:mt-3'>
                            <input type='text' value={search_text} onChange={(e) => set_search_text(e.target.value)} placeholder='Search...' className='pl-8 border-[#57575733] w-[300px] mobilexl:w-full' />
                            <div className='absolute top-1/2 left-2 -translate-y-1/2'>
                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="9.58317" cy="10.0833" r="7.91667" stroke="#575757" strokeWidth="1.5" />
                                    <path d="M15.4165 15.9166L18.3332 18.8333" stroke="#575757" strokeWidth="1.5" strokeLinecap="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    {adv_list.length > 0 ? <ul className='mt-5 grid grid-cols-3 gap-5 mobilexl:grid-cols-2 mobile:grid-cols-1'>
                        {adv_list.map(adv => (
                            <li key={adv._id} className="white-box border border-[#57575733]">
                                <img alt={adv.name} src={`${FRONTEND_URL}${adv.image_path}`} className='w-100 rounded-xl h-[250px] object-cover' />
                                <div>
                                    {/* <label className='block text-[#F0643B] my-4'>{post?.tag}</label> */}

                                    <a href={adv.url ?? ""} target="_blank" rel="noopener noreferrer" className="mt-3 font-semibold text-black text-lg flex">
                                        <span className="inset-0" />
                                        {adv.name}
                                        <svg className='ml-auto' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13 11L22 2M22 2H16.6562M22 2V7.34375" stroke="black" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2" stroke="black" strokeWidth="1.5" stroke-linecap="round" />
                                        </svg>
                                    </a>
                                    <div>
                                        {formatDetails(adv.details ?? "")}
                                    </div>
                                    {/* <div className='avt-sec flex items-center mt-4'>
                                        <img src={post.avt} className='w-14 h-14 rounded-full' />
                                        <div className='ml-3'>
                                            <p className='text-black font-bold'>{post?.avtname}</p>
                                            <p>{post.date}</p>
                                        </div>
                                    </div> */}
                                    <ul className="mt-2 flex gap-2 /50" aria-hidden="true">
                                        <li>{formatDate(adv.created_at)}</li>
                                        <li aria-hidden="true">&middot;</li>
                                        <li>{adv.view ?? 0} Views</li>
                                        <li aria-hidden="true">&middot;</li>
                                        <li>{adv.clicks ?? 0} Clicks</li>
                                    </ul>
                                </div>
                            </li>
                        ))}
                    </ul> : <p>No Advertisements found for serach "{search_text}"</p>}
                    <TabPanels className="mt-3">
                        {categories.map(({ name, posts }) => (
                            <TabPanel key={name} className="rounded-xl bg-white/5">
                                
                            </TabPanel>
                        ))}
                    </TabPanels>
                </TabGroup>
            </section>

        </Layout>
    );
}

export default AllAdvs;